import { MinusCircleOffIcon } from './MinusCircleOffIcon';

/**
 * author: Michael Irigoyen
 * id 6A57F7D9-D5F6-42B2-A5E2-D160F7E0DB4B
 * name minus-circle-off
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-circle-off.svg
 * tags
 */
export const DoNotDisturbOffIcon = MinusCircleOffIcon;
export default DoNotDisturbOffIcon